import OcuEntityValidationResult from 'app/admin/common/dto/OcuEntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';
import AspectEditDto from '../dto/AspectEditDto';
import { objArrayToMap } from 'app/admin/common/util/CommonUtil';

class AspectEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'aspectEditControl';
	}

	/**
	 * @return {Promise<AspectEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new AspectEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<AspectEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new AspectEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} name
	 * @return {Promise<AspectEditDto>}
	 */
	getDataByName(name) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getDataByName`, {
					name
				})
				.then(response => resolve(new AspectEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 */
	getImageByAspectId(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getImageByAspectId`, {
					id
				})
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {AspectEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto: { ...dto, roundDigits: objArrayToMap(dto.roundDigits, 'type', 'value') }
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {AspectEditDto} dto
	 * @return {Promise<OcuEntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto: { ...dto, roundDigits: objArrayToMap(dto.roundDigits, 'type', 'value') }
				})
				.then(response => resolve(new OcuEntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new AspectEditService();
